import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

export const NotFoundPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleBack = () => {
    // Se houver histórico útil, volta; senão leva para o dashboard ou landing
    if (window.history.length > 2) {
      navigate(-1);
      return;
    }

    if (user) {
      navigate('/admin', { replace: true });
      return;
    }

    navigate('/', { replace: true });
  };

  const primaryLabel = user ? 'Voltar ao dashboard' : 'Voltar ao início';

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center gap-3">
      <h1 className="display-5 fw-bold">404</h1>
      <p className="text-muted mb-1">Página não encontrada.</p>
      <p className="text-muted">O recurso solicitado não existe ou foi movido.</p>
      <button type="button" className="btn btn-primary" onClick={handleBack}>
        {primaryLabel}
      </button>
    </div>
  );
};
